
import { useTranslation } from 'react-i18next';

export default function Features() {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-layout-grid-line',
      title: t('feature.bio.title'),
      desc: t('feature.bio.desc'),
      gradient: 'from-pink-500 to-pink-600',
    },
    {
      icon: 'ri-qr-code-line',
      title: t('feature.qr.title'),
      desc: t('feature.qr.desc'),
      gradient: 'from-teal-500 to-teal-600',
    },
    {
      icon: 'ri-link',
      title: t('feature.links.title'),
      desc: t('feature.links.desc'),
      gradient: 'from-orange-500 to-orange-600',
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: t('feature.analytics.title'),
      desc: t('feature.analytics.desc'),
      gradient: 'from-indigo-500 to-indigo-600',
    },
    {
      icon: 'ri-palette-line',
      title: t('feature.custom.title'),
      desc: t('feature.custom.desc'),
      gradient: 'from-emerald-500 to-emerald-600',
    },
    {
      icon: 'ri-flashlight-line',
      title: t('feature.team.title'),
      desc: t('feature.team.desc'),
      gradient: 'from-amber-500 to-amber-600',
    },
  ];

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('features.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('features.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-teal-200"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${feature.gradient} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
